var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBookExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 17.1V7.5s4.21-2.06 8 0c3.79-2.06 8.5 0 8.5 0v9.6s-4.02-2.2-8.5 0c-4.48-2.2-8 0-8 0ZM14.49 7c-.33 0-.49.12-.49.35l.2 5.92c0 .19.15.28.45.28h.7c.3 0 .44-.1.44-.28L16 7.35c0-.23-.16-.35-.49-.35h-1.02Zm-.48 8.72c0 .19.15.28.44.28h1.1c.3 0 .44-.1.44-.28v-.77c0-.19-.15-.28-.44-.28h-1.1c-.3 0-.44.1-.44.28v.77Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookExclamation);
export default ForwardRef;